import type { TabConfig } from "./types";

export const WORKFLOW_TAB_KEYS = {
  ASSIGNED_TO_ME: "assigned_to_me",
  ALL_WORKFLOWS: "all_workflows",
} as const;

export const getControlTowerTabs = (): TabConfig[] => [
  {
    key: WORKFLOW_TAB_KEYS.ASSIGNED_TO_ME,
    label: "Assigned to me",
    visible: true,
    testId: "assigned-to-me-tab",
  },
  {
    key: WORKFLOW_TAB_KEYS.ALL_WORKFLOWS,
    label: "All workflows",
    visible: true,
    testId: "all-workflows-tab",
  },
];

export type { TabConfig };
